var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a-card", [
    _c(
      "div",
      { attrs: { id: "whatsapp-wizard" } },
      [
        _c(
          "a-steps",
          {
            style: _vm.stepStyle,
            attrs: { type: "navigation" },
            model: {
              value: _vm.current,
              callback: function ($$v) {
                _vm.current = $$v
              },
              expression: "current",
            },
          },
          [
            _c("a-step", {
              attrs: {
                status: _vm.getStatus(0),
                title: _vm.$t("wp.agreement"),
                disabled: _vm.current !== 0,
              },
            }),
            _vm._v(" "),
            _c("a-step", {
              attrs: {
                status: _vm.getStatus(2),
                title: _vm.$t("wp.activating"),
                disabled: _vm.current !== 2,
              },
            }),
            _vm._v(" "),
            _c("a-step", {
              attrs: {
                status: _vm.getStatus(3),
                title: _vm.$t("wp.authenticating"),
                disabled: _vm.current !== 3,
              },
            }),
            _vm._v(" "),
            _c("a-step", {
              attrs: {
                status: _vm.getStatus(4),
                title: _vm.$t("wp.ready"),
                disabled: _vm.current !== 4,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex justify-content-center" }, [
          _vm.current === 0
            ? _c(
                "div",
                { staticClass: "step step0" },
                [_c("Agreement", { on: { agree: _vm.agree } })],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.current === 2
            ? _c(
                "div",
                { staticClass: "step step2" },
                [
                  _c("Activation", {
                    attrs: { activated: _vm.activationCompleted },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.current === 3
            ? _c(
                "div",
                { staticClass: "step step3" },
                [_c("QRCodeAuthentication")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.current === 4
            ? _c(
                "div",
                { staticClass: "step step4" },
                [_c("WPStatusViewer")],
                1
              )
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }